import React, { useEffect, useState } from "react";
import { Button, CloseButton, Modal } from "react-bootstrap";
import { useDoctors } from "./store";
import Doctor from "assets/svgs/doctor";
import { UserAddOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  assignDoctorAccess,
  autoAssignDoctorRoles,
  disableAssignDoctorStatus,
  getCurrentUserRole,
} from "modules/utilities/utility";

function DoctorsAssignmentModal({ orderId, name, orderStatus }) {
  const {
    isLoading,
    assignDoctor,
    unassignDoctor,
    autoAssignDoctor,
    assignedDoctorsData,
    availableDoctorsData,
    fetchAvailableDoctorsData,
    fetchAssignedDoctorsData
  } = useDoctors();

  const [modalShow, setModalShow] = useState(false);
  const [disabledBtn, setDisableBtn] = useState();
  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [assignedDoctorsID, setAssignedDoctorsID] = useState([]);

  //Added api call for doctor assignment
  useEffect(()=>{
    if(modalShow){
      fetchAvailableDoctorsData();
      fetchAssignedDoctorsData(orderId);
    }
  },[orderId, modalShow])

  const idOfAssignedDoctor = _.map(assignedDoctorsData[0]?.doctor, "user.id");
  useEffect(() => {
    setDisableBtn(disableAssignDoctorStatus.includes(orderStatus));
  }, []);

  useEffect(() => {
    setAvailableDoctors(availableDoctorsData.userRole);
  }, [availableDoctorsData, assignedDoctorsData]);

  useEffect(() => {
    setAssignedDoctorsID(idOfAssignedDoctor);
  }, [availableDoctors, assignedDoctorsData]);

  return (
    <>
      <Tooltip title={name}>
        <div
          className={disabledBtn ? "disabled-action" : ""}
          onClick={() => {
            !disabledBtn && setModalShow(true);
            if (
              autoAssignDoctorRoles.includes(getCurrentUserRole()) &&
              !disableAssignDoctorStatus.includes(orderStatus) &&
              idOfAssignedDoctor.length === 0
            ) {
              autoAssignDoctor(orderId, toast);
            }
          }}
        >
          <span className="mt-n1 bg-primary text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow" id="usedAddId">
            <UserAddOutlined />
          </span>
        </div>
      </Tooltip>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="m"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Assign Doctor
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          {assignedDoctorsData.length ? (
            assignedDoctorsData[0].doctor.map((doctor) => {
              return (
                <div className="d-flex justify-content-between p-2 border rounded m-2">
                  <div className="d-flex">
                    <Doctor gender={doctor?.user?.gender} />
                    <p className="m-0 ms-2">{doctor?.user?.first_name}</p>
                  </div>
                  <div>
                    {assignDoctorAccess.includes(getCurrentUserRole()) && (
                      <Button
                        variant="outline-danger"
                        disabled={isLoading}
                        style={{ width: "8rem" }}
                        onClick={() => {
                          unassignDoctor(
                            orderId,
                            {
                              order_id: orderId,
                              doctor_id: doctor.user.id,
                            },
                            toast
                          );
                        }}
                      >
                        Unassign
                      </Button>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="p-2 m-2 border rounded">
              <Doctor /> No Doctor Assigned
            </div>
          )}
          {assignDoctorAccess.includes(getCurrentUserRole()) &&
            availableDoctors &&
            availableDoctors.length > 0 &&
            availableDoctors
              .filter((doctor) => !assignedDoctorsID.includes(doctor.user.id))
              .map((availableDoctor) => {
                return (
                  <div className="d-flex justify-content-between p-2 border rounded m-2">
                    <div className="d-flex">
                      <Doctor gender={availableDoctor?.user?.gender} />
                      <p className="m-0 ms-2">
                        {availableDoctor?.user?.first_name}
                      </p>
                    </div>
                    <Button
                      disabled={isLoading}
                      variant="outline-success"
                      style={{ width: "8rem" }}
                      onClick={() => {
                        assignDoctor(
                          orderId,
                          {
                            order_id: orderId,
                            user_id: availableDoctor.user.id,
                          },
                          toast
                        );
                      }}
                    >
                      Assign
                    </Button>
                  </div>
                );
              })}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DoctorsAssignmentModal;
